<template>
  <div class="con" ref="missionSide" @click="handleClick">
    <div class="wrapper" v-if="isUnfold">
      <div>
        <svg-icon name="onboarding-v2" class="icon" v-if="!isHover"></svg-icon>
        <svg-icon name="active-onboarding-v2" class="icon" v-else></svg-icon>
      </div>
      <div>Onboarding Task</div>
      <div class="num">
        ({{ onboardedNumber || 0 }}/{{ onboardingTotal || 2 }})
      </div>
    </div>
    <div v-else>
      <SidebarItem
        :route="item"
        :base-path="item.path"
        :active-path="activePath"
        :is-unfold="isUnfold"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import SidebarItem from "./sidebar-item.vue";
import { dispatchCommandLike$ } from "@/shared-services";

export default {
  name: "TrialControl",
  components: { SidebarItem },
  props: {
    isUnfold: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHover: false,
      item: {
        path: "index",
        name: "onboarding",
        disabled: true,
        meta: {
          title: "Onboarding Task  (1/2)",
          icon: "onboarding-v2",
        },
      },
    };
  },
  computed: {
    ...mapState({
      routes: (state) => state.permissionV2.routes,
      demoType: (state) => state.user.demoType,
      expiredDemoAccount: (state) => state.user.expiredDemoAccount,
      quickOnboardStatus: (state) => state.user.quickOnboardStatus,
      onboardedNumber: (state) => state.user.onboardedNumber,
      onboardingTotal: (state) => state.user.onboardingTotal,
    }),
  },
  mounted() {
    this.$refs.missionSide.addEventListener("mouseenter", this.mouseoverFn);
    this.$refs.missionSide.addEventListener("mouseleave", this.mouseoutFn);
  },
  beforeDestroy() {
    this.$refs.missionSide.removeEventListener("mouseenter", this.mouseoverFn);
    this.$refs.missionSide.removeEventListener("mouseleave", this.mouseoutFn);
  },

  methods: {
    handleClick() {
      dispatchCommandLike$.subscribe((x) => x.openMissionPanel());
    },
    mouseoverFn() {
      this.isHover = true;
    },
    mouseoutFn() {
      this.isHover = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  height: 44px;
  display: flex;
  margin: 0 12px;
  padding: 10px 12px;
  width: 216px;
  color: #a4b4d0;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  cursor: pointer;
  .icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  .num {
    font-weight: 400;
    margin-left: 20px;
  }
}

.con {
  margin-bottom: 4px;
}
</style>
